import { Grid } from "theme-ui";
export default Grid;
